import { createSelector } from 'reselect'

import { RootState } from '../../types'

export const selectState = createSelector(
  (s: RootState) => s.importHistory,
  b => b
)

export const areImportsLoading = createSelector(selectState, s => s.loading)

export const getAccountImports = createSelector(selectState, s => s.data)

export const getAccountImportsFilter = createSelector(selectState, s => s.filter)

export const getAccountImportsFilters = createSelector(selectState, s => s.filters)
